import { render, staticRenderFns } from "./NoticeDetailDialog.vue?vue&type=template&id=f1a4d76c&scoped=true&"
import script from "./NoticeDetailDialog.vue?vue&type=script&lang=js&"
export * from "./NoticeDetailDialog.vue?vue&type=script&lang=js&"
import style0 from "./NoticeDetailDialog.vue?vue&type=style&index=0&id=f1a4d76c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1a4d76c",
  null
  
)

export default component.exports